var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadedHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0716 16C32.0716 7.16343 24.9082 0 16.0716 0C13.3318 0 10.749 0.690286 8.49067 1.90629C6.37086 3.05008 4.53516 4.65559 3.11924 6.60419V1.52381H0.0716191V12.1905H10.7383V9.14286H5.08038C6.27758 7.23021 7.951 5.66128 9.93676 4.58971C11.8219 3.57415 13.9303 3.04417 16.0716 3.04762C18.5751 3.04802 21.0247 3.77389 23.1242 5.13742C25.2237 6.50095 26.8831 8.44369 27.9016 10.7306C28.9201 13.0175 29.254 15.5505 28.8629 18.0232C28.4719 20.4959 27.3726 22.8023 25.6982 24.6633C24.0238 26.5243 21.8459 27.8602 19.4281 28.5094C17.0103 29.1585 14.4562 29.0931 12.0748 28.3209C9.69337 27.5488 7.58677 26.1032 6.00984 24.1588C4.4329 22.2145 3.45322 19.8548 3.18933 17.3653L3.03086 15.8491L0 16.1676L0.158476 17.6823C1.00114 25.728 7.8019 32 16.0716 32C24.9082 32 32.0716 24.8366 32.0716 16ZM14.5478 6.85714V16.6309L19.8811 21.9642L22.0358 19.8095L17.5954 15.3691V6.85714H14.5478Z",
    fill: "#7C8DB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadedHistory);
export default __webpack_public_path__ + "static/media/uploaded-history.f88be19e378599107fd586ca3ade5896.svg";
export { ForwardRef as ReactComponent };